import "./VariableBlock.css";
import editorAction from "/src/features/editor/actions/editorAction";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";

// Simple Components to see a variable block
function VariableBlock({id, name, type}) {

    const { deleteVariable } = editorAction();
    return (
        <div className="var_block">
            <label className="name">{`[${name.toUpperCase()}]`}</label>
            <label className="type">{type.name}</label>
            <div className="actions">
            <IconButton className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" onClick={() => deleteVariable(id)}></IconButton>
            </div>
            
        </div>
    )
}

export default VariableBlock;